
import React from "react";
import { Phone } from "lucide-react";

const ContactQuickInfo = () => (
  <>
    {/* Map (placeholder) */}
    <div className="w-full h-64 bg-gray-200 rounded-xl mb-8 overflow-hidden">
      <iframe
        title="Truecore Locations"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.3098301833007!2d72.8487212!3d19.1285427!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9da695e73a1%3A0x6d2aaae3ab9737c4!2sAndheri%20East%2C%20Mumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1612345678901!5m2!1sen!2sin"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen={false}
        loading="lazy"
      ></iframe>
    </div>
    {/* Our Locations section appears above (separate component) */}
    {/* Quick Contact */}
    <div className="mt-8 bg-primary/5 p-6 rounded-lg border border-primary/20">
      <h4 className="text-lg font-bold mb-4">Need Immediate Assistance?</h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <a href="tel:02269647168" className="tech-btn-outline flex items-center justify-center">
          <Phone className="mr-2 h-5 w-5" />
          Call Us
        </a>
        <a href="https://wa.me/912269647168" className="tech-btn-outline flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16" className="mr-2">
            <path d="M13.601 2.326A7.854 7.854 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          WhatsApp
        </a>
      </div>
    </div>
  </>
);

export default ContactQuickInfo;
